<template>
  <mj-tracks-table
    class="-mx-4 sm:-mx-10 mb-16"
  >
    <mj-tracks-table-head />
    <mj-tracks-table-row
      v-for="track in tracks"
      :key="track.id"
      :track="track"
      :stored-tracks="storedTracks"
      :window-width="windowWidth"
      @track-selected="onTrackSelected"
    />
  </mj-tracks-table>
</template>

<script>
import TracksTable from '@/components/tracks/table/TracksTable.vue';
import TracksTableHead from '@/components/tracks/table/TracksTableHead.vue';
import TracksTableRow from '@/components/tracks/table/TracksTableRow.vue';

export default {
  name: 'TrackList',

  components: {
    'mj-tracks-table': TracksTable,
    'mj-tracks-table-head': TracksTableHead,
    'mj-tracks-table-row': TracksTableRow,
  },

  props: {
    tracks: {
      type: Array,
      required: true,
      default: () => [],
    },

    storedTracks: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  data() {
    return {
      windowWidth: null,
    };
  },

  methods: {
    onTrackSelected(track) {
      this.$emit('track-selected', track);
    },
  },

  mounted() {
    this.windowWidth = window.innerWidth;

    const onResizeListener = () => {
      this.windowWidth = window.innerWidth;
    };

    window.addEventListener('resize', onResizeListener);

    this.$once('hook:destroyed', () => {
      window.removeEventListener('resize', onResizeListener);
    });
  },

};

</script>
